"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonVariantStyles = void 0;
var polished_1 = require("polished");
var theme_1 = __importDefault(require("../../theme"));
function getButtonVariantStyles(_a) {
    var variant = _a.variant, format = _a.format, size = _a.size;
    var variantsTheme = {
        primary: {
            backgroundColor: theme_1.default.colorsPalette.blue.default,
            color: theme_1.default.colorsPalette.white.default,
        },
        secondary: {
            backgroundColor: theme_1.default.colorsPalette.gray.light,
            color: theme_1.default.colorsPalette.white.default,
        },
        danger: {
            backgroundColor: theme_1.default.colorsPalette.red.default,
            color: theme_1.default.colorsPalette.white.default,
        },
        success: {
            backgroundColor: theme_1.default.colorsPalette.green.default,
            color: theme_1.default.colorsPalette.white.default,
        },
    };
    var button = variantsTheme[variant];
    var variantStyle = {
        backgroundColor: format === "outline" || format === "link"
            ? "transparent"
            : button.backgroundColor,
        border: format === "outline" ? "1px solid " + button.backgroundColor : "none",
        color: format === "outline" || format === "link"
            ? button.backgroundColor
            : button.color,
        backgroundColorOnHover: format === "outline"
            ? button.backgroundColor
            : format === "link"
                ? "transparent"
                : polished_1.darken(0.12, button.backgroundColor),
        colorOnHover: format === "link"
            ? polished_1.darken(0.12, button.backgroundColor)
            : button.color,
        fontSize: size === "small" ? theme_1.default.fontSizes.small : theme_1.default.fontSizes.regular,
        padding: format === "link" ? 0 : size === "small" ? "4px 16px" : "12px 16px",
        minWidth: format === "link" ? "unset" : "120px",
    };
    return variantStyle;
}
exports.getButtonVariantStyles = getButtonVariantStyles;
//# sourceMappingURL=helpers.js.map